module.exports = __webpack_public_path__ + "static/media/un-employment-user.6ff71c14.svg";